<template>
  <div class="offers-view">
    <transition name="fade" mode="out-in">
      <spinner v-if="inProgress"></spinner>
      <div v-else>
        <filters
          :sortBy="sortBy"
          @changeSorting="onFilterChangeSorting"
        >

        </filters>
        <ul v-if="!isFailed" class="offers-list">
          <li class="offers-list__item" v-for="offer in offers" :key="offer.id">
            <offer-row :offer="offer"></offer-row>
          </li>
        </ul>
        <p v-else>Błąd pobierania</p>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';

import Filters from '@/components/offers/Filters.vue';
import OfferRow from '@/components/offers/OfferRow.vue';
import Spinner from '@/components/Spinner.vue';

export default {
  computed: {
    offers() {
      const sorting = {
        region: ['region', 'lastPrice'],
        name: ['name', 'lastPrice'],
        lastPrice: ['lastPrice'],
      };

      const sortConfig = sorting[this.$store.state.offers.filter.sort.by || 'name'];

      return _.sortBy(this.$store.state.offers.data, sortConfig);
    },

    inProgress() {
      return this.$store.state.offers.inProgress;
    },

    isFailed() {
      return this.$store.state.offers.isFailed;
    },

    sortBy() {
      return this.$store.state.offers.filter.sort.by;
    },
  },

  created() {
    this.$store.dispatch('fetchOffers');
  },

  methods: {
    onFilterChangeSorting(data) {
      this.$store.dispatch('setSorting', data);
    },
  },

  components: {
    Filters,
    OfferRow,
    Spinner,
  },
};
</script>

<style lang="scss">
  .offers-view {
    max-width: 1024px;
    margin: 0 auto;
  }

  .offers-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .offers-list__item {
    border-bottom: 1px solid #b6b6b6;
    margin: 0;
  }
</style>
